export const SLIDESHOWS_GET = 'SLIDESHOWS_GET';